<template>
  <TeaserAccountTile>
    <template v-slot:component>
      <Card class="card" :title="$t('vehicleSaleNotificationPage.title')">
        <template v-slot:content>
          <div class="card-header">
            {{ $t('vehicleSaleNotificationPage.cardHeader') }}
          </div>
          <div class="content-text" v-dompurify-html="contentText"></div>
        </template>
        <template v-slot:footer>
          <div class="footer-cta footer-cta--left">
            <CustomButton
              @click="goToOverview"
              id="back-to-overview-button"
              :buttonColor="ButtonColor.LINK"
              >{{ $t('vehicleSaleNotificationPage.backToOverview') }}
            </CustomButton>
          </div>
        </template>
      </Card>
    </template>
    <template v-slot:image>
      <TeaserAccount></TeaserAccount>
    </template>
  </TeaserAccountTile>
</template>

<script lang="ts" setup>
import { navigate } from '@/utils/NavigationUtils'
import { ButtonColor, Card, CustomButton } from 'de-zurich-ui-library'
import TeaserAccount from '@/componentsTenant/rahmen/images/TeaserAccount.vue'
import TeaserAccountTile from '@/components/rahmen/TeaserAccountTile.vue'

// URL synchron berechnen
// TODO: https://jira.zurich.com/browse/KPONE-943
const isTest = globalThis.location.origin.includes('test.da-direkt.de')
const autoAbmeldenUrl = isTest
  ? 'https://test.da-direkt.de/autoversicherung/ratgeber/auto-abmelden'
  : 'https://www.da-direkt.de/autoversicherung/ratgeber/auto-abmelden'

// Content-Text direkt mit i18n und URL auflösen
const contentText = `Sobald wir die Bestätigung der Zulassungsstelle erhalten haben, dass Ihr Fahrzeug abgemeldet wurde, werden wir Ihren Vertrag stornieren. Anschließend erhalten Sie von uns eine schriftliche Bestätigung mit der Vertragsabrechnung.<br><br>Weitere wichtige Informationen zum Thema finden Sie in unserem Ratgeber <a href="${autoAbmeldenUrl}" target="_blank">Auto abmelden</a>.<br>Wir hoffen, dass Sie mit unseren Leistungen zufrieden waren und dass wir Sie auch bei einem neuen Kfz-Vertrag wieder als Versicherungspartner unterstützen können.`

function goToOverview(): void {
  navigate('/ueberblick')
}
</script>
<style lang="scss" scoped>
.card-header {
  font-family: var(--f-primary-bold), serif;
  font-size: 16px;
  margin-bottom: 4px;
}
:deep(.card) {
  margin-bottom: 0 !important;
}
</style>
